export default __webpack_public_path__ + "ffb07c0a5c7f4c7043c79e1a98242021.svg";